import { theme } from '@/stitches.config';
import { ColorsBuilder } from './colors.type';

const colorsArr: ColorsBuilder = {};

const buildColors = (): ColorsBuilder => {
  for (const color in theme.colors) {
    colorsArr[color] = (theme?.colors as any)[color].value;
  }

  return colorsArr;
};

const colors = buildColors();

export default colors;
